import React from 'react';
import { PlayIcon as HeroPlayIcon } from '@heroicons/react/solid';
import { Icon, IconProps } from '../Icon';

type PlayIconProps = Omit<IconProps, 'children'>;

export const PlayIcon: React.FC<PlayIconProps> = (props) => {
    return (
        <Icon {...props}>
            <HeroPlayIcon />
        </Icon>
    );
};
